export const geschiedenis = [
  "Renaissance",
  "Middeleeuwen",
  "Koude Oorlog",
  "Wereldoorlog",
  "Oudheid",
  "Ontdekkingsreizen",
  "Slavernij",
  "Industriële Revolutie",
  "Feodale samenleving",
  "Griekse beschaving",
  "Romeinse Rijk",
  "Franse Revolutie",
  "Amerikaanse Revolutie",
  "Kolonialisme",
  "Verlichting",
  "Honderdjarige Oorlog",
  "Kruistochten",
  "Tweede Wereldoorlog",
  "Eerste Wereldoorlog",
  "Berlijnse Muur",
  "Koude Oorlog",
  "Gouden Eeuw",
  "Reformatie",
  "Victoriaanse tijdperk",
  "Apartheid",
  "Spaanse Inquisitie",
  "Holocaust",
  "Val van het Romeinse Rijk",
  "Russische Revolutie",
  "Ontdekkingsreizen",
  "Val van de Bastille",
  "Slag bij Waterloo",
  "Slag bij Stalingrad",
  "Verdrag van Versailles",
  "Rusland",
  "Egypte",
  "China",
  "India",
  "Griekenland",
  "Rome",
  "Vikingen",
  "Azteken",
  "Inca's",
  "Maya's",
  "Nelson Mandela",
  "Martin Luther King Jr.",
  "Julius Caesar",
  "Cleopatra",
  "Napoleon Bonaparte",
  "Winston Churchill",
  "Abraham Lincoln",
  "Mahatma Gandhi",
  "Alexander de Grote",
  "George Washington",
  "Johannes Gutenberg",
  "Leonardo da Vinci",
  "Michelangelo",
  "Isaac Newton",
  "Albert Einstein",
  "Karel de Grote",
  "Joan of Arc",
  "Marco Polo",
  "Galileo Galilei",
  "Willem de Veroveraar",
  "Hannibal",
  "Koningin Elizabeth I",
  "Koningin Victoria",
  "Johannes Kepler",
  "Charles Darwin",
  "Socrates",
  "Plato",
  "Aristoteles",
  "Confucius",
  "Koningin Nefertiti",
  "Cleopatra",
  "Koningin Hatshepsut",
  "Julius Caesar",
  "Alexandra de Grote",
  "Koningin Zenobia",
  "George Washington",
  "Benjamin Franklin",
  "Thomas Edison",
  "Henry Ford",
  "Wright Brothers",
  "Rosa Parks",
  "Nelson Mandela",
  "Winston Churchill",
  "Adolf Hitler",
  "Joseph Stalin",
  "Mao Zedong",
  "Mahatma Gandhi",
  "Malcolm X",
  "Neil Armstrong",
  "Amelia Earhart",
  "Marie Curie",
  "Albert Einstein",
  "Alexander Graham Bell",
  "Steve Jobs",
  "Bill Gates",
  "Nikola Tesla",
  "Charles Darwin",
  "Sigmund Freud",
  "Paus Johannes Paulus II",
  "Mohammed Ali",
  "Michael Jordan",
  "Pelé",
  "Beethoven",
  "Mozart",
  "Elvis Presley",
  "The Beatles",
  "Bob Dylan",
  "Michelangelo",
  "Pablo Picasso",
  "Vincent van Gogh",
  "Salvador Dali",
  "Andy Warhol",
  "Leonardo da Vinci",
  "Georgia O'Keeffe",
  "Frida Kahlo",
  "Banksy",
  "Piet Mondriaan",
  "Claude Monet",
  "Vincent van Gogh",
  "Rembrandt van Rijn",
  "Salvador Dali",
  "Pablo Picasso",
  "Andy Warhol",
  "Johannes Vermeer",
  "Edward Hopper",
  "Auguste Rodin",
  "Jackson Pollock",
  "Henri Matisse",
  "Edgar Degas",
  "Winslow Homer",
  "Paul Cézanne",
  "Paul Gauguin",
  "Georges Seurat",
  "René Magritte",
  "Marc Chagall",
  "Henri Rousseau",
  "Yoko Ono",
  "Ai Weiwei",
  "Damien Hirst",
  "Jeff Koons",
  "Marcel Duchamp",
  "Piet Mondriaan",
  "Wassily Kandinsky",
  "Frida Kahlo",
  "Diego Rivera",
  "Joan Miró",
  "Eenhoorn",
  "Sfinx",
  "Piramide",
  "Grote Muur van China",
  "Colosseum",
  "Stonehenge",
  "Machu Picchu",
  "Taj Mahal",
  "Parthenon",
  "Eiffeltoren",
  "Vrijheidsbeeld",
  "Chinese Muur",
  "Petra",
  "Kremlin",
  "Acropolis",
  "Alhambra",
  "Angkor Wat",
  "Chichén Itzá",
  "Christus de Verlosser",
  "Mesa Verde",
  "Versailles",
  "Notre-Dame",
  "Sint-Pietersbasiliek",
  "Topkapi-paleis",
  "Sydney Opera House",
  "Pantheon",
  "Buckingham Palace",
  "Kasteel Neuschwanstein",
  "Musee du Louvre",
  "Guggenheim Museum",
  "British Museum",
  "Metropolitan Museum of Art",
  "Hermitage Museum",
  "Uffizi Gallery",
  "Rijksmuseum",
  "Vaticaanse Musea",
  "Groot Museum",
  "Prado Museum",
  "Nationale Galerij",
  "National Air and Space Museum",
  "National Museum of Natural History",
  "British Library",
  "Library of Congress",
  "Museum of Modern Art",
  "Smithsonian Institution",
  "V&A Museum",
  "Academie voor Schone Kunsten",
  "Pergamonmuseum",
  "Altes Museum",
  "Galerie degli Uffizi",
  "Tate Modern",
  "Het Louvre",
  "Het Rijksmuseum",
  "Van Gogh Museum",
  "Het British Museum",
  "Het Metropolitan Museum of Art",
  "Vaticaanse Musea",
  "National Gallery",
  "Smithsonian Institution",
  "Museum of Modern Art",
  "Musée d'Orsay",
  "Guggenheim Museum",
];
